import { DriverDto } from "@core/models/planner-models/driver.model";
import { VehicleDto } from "@core/models/planner-models/vehicle.model";
import { RegionModel } from "@core/models/region.model";

export interface DriverVehiclePairModel {
  driverId: number;
  vehicleId: number;
  trailerId?: number;
  model: string;
  loadCapacity: number;
  codeFromDescription: string;
  registrationNumber: string;
  trailerRegistrationNumber: string;
  trailerloadCapacity: number;
  trailerModel: string;
  driverDisplayName: string;
  vehicleName: string;
  trailerName: string;
  vehicleRegionId: number;
  region: string;
  driverDisplayNameNormalized: string
  registrationNumberNormalized: string;
  trailerRegistrationNumberNormalized: string;

  driver: DriverDto;
  vehicle: VehicleDto;
  trailer?: VehicleDto;
}

// TODO[MM] PRZEROBIĆ TO MOŻĘ NA ZŁOŻENIE TYCH DWÓCH PAR: driver i vehicle - bo obsługa nowych pól robi się coraz trudniejsza 
export function mapDriverResponseToUIResponse(driver: DriverDto, vehicle: VehicleDto, trailer: VehicleDto | undefined, regions: RegionModel[]): DriverVehiclePairModel {
  return {
    vehicleId: vehicle.Id,
    driverId: driver.Id,
    trailerId: trailer?.Id,
    codeFromDescription: vehicle.Description || '',
    driverDisplayName: driver.DisplayName,
    loadCapacity: vehicle.LoadingCapacity,
    model: vehicle.Model || '',
    vehicleName: vehicle.Name,
    trailerName: trailer ? trailer.Name : '',
    region: regions.find(r => r.Id === vehicle.RegionId)?.Name || '',
    vehicleRegionId: vehicle.RegionId,
    registrationNumber: vehicle.RegistrationNumber,
    trailerRegistrationNumber: trailer ? trailer.RegistrationNumber : '',
    trailerloadCapacity: trailer ? trailer.LoadingCapacity : 0,
    trailerModel: (trailer && trailer.Model) ? trailer.Model : '',
    driverDisplayNameNormalized: driver.DisplayName.toLowerCase(),
    trailerRegistrationNumberNormalized: trailer ? trailer.RegistrationNumber.toLocaleLowerCase() : '',
    registrationNumberNormalized: vehicle.RegistrationNumber.toLowerCase(),

    driver: driver,
    vehicle: vehicle,
    trailer: trailer
  };
}